(() => {
  const SELECTOR = 'product-info .m-media-gallery';

  function bindTrackpadGallery(gallery) {
    if (!gallery || gallery.dataset.wnTrackpadBound === 'true') return;

    const surface = gallery.querySelector('.m-media-gallery__inner');
    if (!surface) return;

    gallery.dataset.wnTrackpadBound = 'true';

    let accumulatedDelta = 0;
    let triggeredForGesture = false;
    let gestureEndTimer;

    surface.addEventListener(
      'wheel',
      (event) => {
        if (window.innerWidth < 768 || event.ctrlKey) return;

        const swiper = gallery.slider;
        if (!swiper || typeof swiper.slideNext !== 'function' || typeof swiper.slidePrev !== 'function') return;

        const absX = Math.abs(event.deltaX);
        const absY = Math.abs(event.deltaY);

        // IMPORTANT: vertical two-finger gestures must always scroll the page.
        // Only a clearly horizontal trackpad gesture should browse product media.
        const isHorizontalGesture = absX > 0.5 && absX > absY * 1.25;
        if (!isHorizontalGesture) {
          accumulatedDelta = 0;
          triggeredForGesture = false;
          return;
        }

        event.preventDefault();

        clearTimeout(gestureEndTimer);
        gestureEndTimer = setTimeout(() => {
          accumulatedDelta = 0;
          triggeredForGesture = false;
        }, 220);

        if (triggeredForGesture) return;

        accumulatedDelta += event.deltaX;
        if (Math.abs(accumulatedDelta) < 18) return;

        triggeredForGesture = true;
        if (accumulatedDelta > 0) {
          swiper.slideNext(420);
        } else {
          swiper.slidePrev(420);
        }
      },
      { passive: false }
    );
  }

  function initTrackpadGalleries(root = document) {
    root.querySelectorAll(SELECTOR).forEach(bindTrackpadGallery);
  }

  function init() {
    initTrackpadGalleries(document);
    // product-media.js is deferred; this catches the gallery after Swiper init.
    setTimeout(() => initTrackpadGalleries(document), 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTrackpadGalleries(event.target || document);
    setTimeout(() => initTrackpadGalleries(event.target || document), 250);
  });
})();
